import * as React from 'react';
import { Box } from '@mui/material';
import * as authService from '../services/auth';
import frusLogo from '../assets/images/new-frus-logo-no-bg.png';

const backgroundZIndex = 10000;

const backgroundSx = {
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  position: 'fixed',
  background: '#f4f4f4',
  zIndex: backgroundZIndex,
};
const imageContainerSx = {
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: backgroundZIndex + 1,
};

const OAuthCallback = () => {
  authService.handleAuthenticationPopupCallback();

  return (
    <>
      <Box sx={backgroundSx} />

      <Box sx={imageContainerSx}>
        <img className="splashscreen" src={frusLogo} alt="splash screen" />
      </Box>
    </>
  );
};

export default OAuthCallback;
